/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('QuestStatusCtrl', function($scope, $route, $routeParams, $uibModal, Activity, Conversation, ErrorThrower) {
    $scope.new_conversation =
        {content: ''};

    $scope.lock_validation = false;

    const errorManager = ErrorThrower({
        'You need to validate the dependency for this stage': 'Vous devez valider les dépendances de cette étape avant.',
        'Stage has ended':       'L\'étape est terminée, vous ne pouvez plus de faire demande de validation.',
        'Stage has not started': 'L\'étape n\'a pas encore commencé.',
        'Bad Request':           'Une erreur est survenue. Merci de réessayer plus tard.',
        'Forbidden':             'Vous ne pouvez pas faire de demande de validation.'
    });

    Activity
    .mygroup($routeParams)
    .$promise
    .then(mygroup => $scope.my_group = mygroup);

    $scope.open = function() {
        const modalInstance = $uibModal.open({
            templateUrl: 'directives/widget/quest_status/modal_template.html',
            controller:  'ModalConversationCtrl',
            size:        'lg',
            resolve: {
                conversation() { return $scope.stage.validation.conversation; },
                me() { return $scope.me; }
            }
        });

        modalInstance
        .result
        .then($scope.validationRequest);

        return modalInstance;
    };

    $scope.cancelRequest = () => Activity
    .cancel({
        session_id:  $scope.quest.session_id,
        activity_id: $scope.quest.activity_id,
        stage_name:  $scope.stage.name,
        group_id:    $scope.my_group.id}).$promise
    .then(() => $route.reload()).catch(api_error => errorManager.minor(api_error.statusText));

    $scope.validationRequest = function(body = null) {
        if (true === $scope.lock_validation) {
            return;
        }
        $scope.lock_validation = true;
        if (null === body) { body = $scope.new_conversation; }

        return Activity
        .askValidation({
            session_id:  $scope.quest.session_id,
            activity_id: $scope.quest.activity_id,
            stage_name:  $scope.stage.name,
            group_id:    $scope.my_group.id
        }
        , body)
        .$promise
        .then(() => $route.reload()).catch(function(api_error) {
            if (api_error.data != null) {
                return errorManager.minor(api_error.data);
            } else {
                return errorManager.minor(api_error.statusText);
            }}).finally(() => $scope.lock_validation = false);
    };

    return $scope.hasPassed = stage_date => moment() > moment(stage_date);
});
